export * from './browser.types';

import {
  BrowserMessage,
  BrowserMessageForResponse,
  BrowserMessageReceiveResponse,
  BrowserMessageReceiveType,
  BrowserMessageResponse,
  BrowserMessageType,
  CommonMessageType,
} from './browser.types';
import {
  cancelExchange as internalCancelExchange,
  exchangeElectronMessage as internalExchangeElectronMessage,
  sendElectronMessage as internalSendElectronMessage,
  isElectron,
} from './shared.app-utils';

/**
 * Sends a message to the electron backend without repeating the "window.postMessage" stuff every time.
 */
export const sendElectronMessage = (message: BrowserMessage): void =>
  internalSendElectronMessage(message);

/**
 * Sends a message with the specified messageType to the lexian-browser and handles the response's
 * payload with the specified responsePayloadHandler.
 *
 * If the type is not included in the response the event is _not_ handled.
 */
export const exchangeElectronMessage = <T extends BrowserMessageForResponse>(
  message: T,
  responsePayloadHandler: (response: BrowserMessageResponse[T['type']]) => void
): void => internalExchangeElectronMessage(message, responsePayloadHandler);

/**
 * Cancel an exception for the given message type.
 */
export const cancelExchange = (
  type: BrowserMessageType | CommonMessageType
): void => internalCancelExchange(type);

/**
 * Registers a message receiver which receives messages from the electron backend via the custom api receive method
 * This should only be called once
 */
export const registerElectronMessageReceiver = <
  T extends BrowserMessageReceiveType,
>(
  messageType: T,
  handler: (response: BrowserMessageReceiveResponse[T]) => void
): void => {
  if (isElectron()) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    window.api?.receive(messageType, handler);
  }
};
